export const checkIsTherapist = () => {
    const { origin } = window.location;
    return origin.includes('therapist') || origin.includes('easy-massage-web.');
}